
<!-- New note mode -->
<div *ngIf="!addendumMode && note" class="flex flex-column overflow-y-scroll">
    <div class="m-2 mt-0 pt-3 field flex-auto">
        <p-floatLabel>
            <input id="subject" type="text" pInputText [(ngModel)]="note.subject" style="width:100%">
            <label for="subject">Subject</label>
        </p-floatLabel>
    </div>
    <div class="m-2 flex align-items-center gap-2">
        <p-dropdown [(ngModel)]="category" [options]="categoryOptions" optionLabel="label" optionValue="value"
                    [showClear]="true" placeholder="Category" [style]="{'min-width':'12rem'}"></p-dropdown>
    </div>
    <div class="m-2 field">
        <p-editor [(ngModel)]="note.body" [style]="{ height: '250px' }" />
    </div>
    <div class="flex mt-2 justify-content-center button-container">
        <p-button label="Save" icon="pi pi-check" (onClick)="saveButtonPressed($event)" [disabled]="!allowSave()"></p-button>
        <p-button label="Cancel" icon="pi pi-times" severity="danger" (onClick)="cancelButtonPressed($event)"></p-button>
        <p-button *ngIf="editingNote" label="Delete" icon="pi pi-trash" severity="danger" (onClick)="deleteButtonPressed($event)"></p-button>
    </div>
</div>

<div *ngIf="addendumMode && addendumNote" class="flex flex-column">
    <div class="m-2 field">
        <div class="border-1 surface-border border-round p-3 surface-ground text-color-secondary note-body"
             style="cursor:not-allowed; user-select:none;"
             [innerHTML]="addendumNote.body">
        </div>
        <small class="text-color-secondary ml-1">Original note — cannot be edited</small>
    </div>

    <div class="m-2" *ngIf="addendumNote.addenda?.length">
        <p-button [text]="true" size="small" severity="secondary"
            [icon]="showPreviousAddenda ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"
            [label]="(showPreviousAddenda ? 'Hide' : 'Show') + ' previous addenda (' + addendumNote.addenda.length + ')'"
            (onClick)="showPreviousAddenda = !showPreviousAddenda">
        </p-button>
        <div *ngIf="showPreviousAddenda" class="border-1 surface-border border-round overflow-y-scroll mt-1" style="max-height: 160px;">
            <div *ngFor="let addendum of addendumNote.addenda; let last = last"
                 class="p-3" [class.border-bottom-1]="!last" [class.surface-border]="!last">
                <div class="flex gap-3 mb-1 text-sm text-color-secondary">
                    <span><i class="pi pi-user mr-1"></i>{{addendum.createdBy.fullName}}</span>
                    <span><i class="pi pi-calendar-clock mr-1"></i>{{addendum.createDate | date:'short'}}</span>
                </div>
                <div [innerHTML]="addendum.body" class="text-sm note-body"></div>
            </div>
        </div>
    </div>

    <p-divider align="left">
        <span class="font-semibold text-orange-500">Addendum</span>
    </p-divider>
    <div class="m-2 field">
        <p-editor [(ngModel)]="addendumBody" [style]="{ height: '180px' }" />
    </div>
    <div class="flex mt-2 justify-content-center">
        <p-buttonGroup>
            <p-button label="Save Addendum" icon="pi pi-check" (onClick)="saveAddendumPressed($event)" [disabled]="!allowSaveAddendum()"></p-button>
            <p-button label="Cancel" icon="pi pi-times" severity="danger" (onClick)="cancelButtonPressed($event)"></p-button>
        </p-buttonGroup>
    </div>
</div>
